import { memo } from 'react';

import { Table } from 'semantic-ui-react';
import { MonthPicker } from './MonthPicker';
import { DayOfTheWeekBadge } from 'components';
import styled from '@emotion/styled';
import classNames from 'classnames';
import { format } from 'date-fns';

interface MemoTableRowProps {
  date: Date;
  onDateChange: (date: Date | null) => void;
}

export const MemoTableHeader: React.FC<MemoTableRowProps> = memo(({ date, onDateChange }) => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  return (
    <S.TableHeader className={classNames({ sticky: true })}>
      <Table.Row>
        <S.TableHeaderCell>
          <MonthPicker date={date} onChange={onDateChange} />
        </S.TableHeaderCell>
        {Array.from({ length: daysInMonth }).map((_, cellIndex) => {
          const currentDate = new Date(year, month, cellIndex + 1);
          return (
            <S.TableHeaderCell key={cellIndex + 1}>
              <S.StyledDiv>
                <span>
                  {currentDate.getDate()} {format(currentDate, 'MMM')}
                </span>
                <span>
                  <DayOfTheWeekBadge date={format(currentDate, 'yyyy-MM-dd')} />
                </span>
              </S.StyledDiv>
            </S.TableHeaderCell>
          );
        })}
      </Table.Row>
    </S.TableHeader>
  );
});

const S = {
  TableHeader: styled(Table.Header)`
    background: inherit;
    padding: 10px;
    .ui.table > &.sticky {
      position: sticky;
      top: 0;
      left: 0;
      z-index: 1;
    }
  `,

  TableHeaderCell: styled(Table.HeaderCell)`
    padding: 10px;
    border-right: 1px solid rgba(34, 36, 38, 0.1);
    border-bottom: 1px solid rgba(34, 36, 38, 0.1);
  `,

  StyledDiv: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  `,
};
